export class NabcGlyph {
  private _basicGlyph: string;
  private _pitch: string;
  private _modifier?: string;

  get basicGlyph() {
    return this._basicGlyph;
  }

  get pitch() {
    return this._pitch[1];
  }

  get modifier() {
    return this._modifier;
  }

  constructor(
    basicGlyph: string,
    pitch?: string,
    modifier?: string,
  ) {
    this._basicGlyph = basicGlyph;
    this._pitch = pitch || 'jf';
    this._modifier = modifier;
  }
}
